export const SET_CUSTOMER_SERVICE = 'app/WithCustomerService/SET_CUSTOMER_SERVICE';
export const WITH_CUSTOMER_SERVICE = 'WithCustomerService';
